<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Create Profile</h4>
    </div>
    <div class="card-body">
      <form>
        <div class="row">
          <div class="col-md-4">
            <fg-input type="text"
                      label="Company"
                      required
                      placeholder="Company"
                      v-model="user.company">
            </fg-input>
          </div>
          <div class="col-md-2">
            <fg-input
                      label="Role"
                      required
                      >
              <el-select class="select-primary"
                         size="large"
                         placeholder="Single Select"
                         v-model="user.role">

                <el-option value="agent" label="agent">

                </el-option>
                <el-option value="commercial" label="commercial">

                </el-option>
                <el-option value="supplier" label="supplier">

                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-2">
            <fg-input type="text"
                      label="Username"
                      required
                      placeholder="Username"
                      v-model="user.login">
            </fg-input>
          </div>
          <div class="col-md-2">
            <fg-input type="password"
                      label="Password"
                      required
                      placeholder="Change password"
                      v-model="user.password">
            </fg-input>
          </div>
          <div class="col-md-2">
            <fg-input type="number"
                      label="Commission %"
                      required
                      placeholder="Commission%"
                      v-model="user.commission">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="First Name"
                      placeholder="First Name"
                      v-model="user.first_name">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Last Name"
                      placeholder="Last Name"
                      v-model="user.last_name">
            </fg-input>
          </div>
          <!--
          <div class="col-md-4">
            <fg-input type="date"
                      label="Birthday"
                      placeholder="Birthday"
                      v-model="user.birthday">
            </fg-input>
          </div>
          -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <fg-input type="text"
                      label="Address"
                      placeholder="Home Address"
                      v-model="user.address">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="City"
                      placeholder="City"
                      v-model="user.locality">
            </fg-input>
          </div>

          <div class="col-md-6">
            <fg-input type="number"
                      label="Postal Code"
                      placeholder="ZIP Code"
                      v-model="user.postal_code">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Phone"
                      placeholder="Phone"
                      v-model="user.phone">
            </fg-input>
          </div>

          <div class="col-md-6">
            <fg-input type="text"
                      label="Email"
                      required
                      placeholder="Email"
                      v-model="user.email">
            </fg-input>
          </div>
        </div>


        <div class="text-center">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="createProfile">
            Create Profile
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>

  </div>
</template>
<script>
  export default {
    data () {
      return {
        user : { role: 'agent'}
      }
    },
    mounted() {
    },
    methods: {
      createProfile () {
        if(this.user.email != '' && this.user.role != '' && this.user.company != '' && this.user.username != '' && this.user.password != '') {
          this.$http({
            method: 'post',
            url: this.$apiUrl + '/user/user',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            params: this.user,
          }).then(response => (
                  this.$notify({
                    message: 'profile created',
                    type: 'success',
                    horizontalAlign: 'center',
                    verticalAlign: 'top'
                  }),
                          this.$router.push({path: '/search/users'})
          )).catch(err => {
            this.$notify({
              message: 'Impossible to create this profile',
              type: 'danger',
              horizontalAlign: 'center',
              verticalAlign: 'top'
            })
          })
        } else {
          this.$notify({
            message: 'Fill the form',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        }



      }
    }
  }

</script>
<style>

</style>
